import { UserDetail } from '@/common/models/UserDetail';
import { UserRoleAssignment } from '@/common/models/UserRoleAssignment';
import { TenantUser, TenantDetailsApi, TenantUserInvitation, CloudSightDate} from '@/common/models';
import UserDetailsRole from '@/common/models/UserDetailsRole';
import { TenantRoleType } from '@/common/viewModels/Enums';
import { RoleAssignmentProperty } from '@/common/models/RoleAssignmentProperty';

export class UserDetailsHelper {

  static fetchKeyName(userRoleAssignment?: UserRoleAssignment): string {
    const scopeSplitArray: string[] | undefined = userRoleAssignment!.scope!.split('/');
    const scopeName: string = scopeSplitArray![scopeSplitArray!.length - 2];
    if (scopeName === 'organizations') {
      return 'Workspace';
    } else if (scopeName === 'accounts') {
      return 'Cloud';
    } else if (scopeName === 'gateways') {
      return 'Cloud Connector';
    } else {
      return 'Tenancy';
    }
  }

  static createUserDetailsView(currentTenant: TenantDetailsApi, userDetails: UserDetail, userRoleAssignments?: UserRoleAssignment[]): UserDetail {
    const roleAssignmentProperties: RoleAssignmentProperty[] = [{
      scope: `/tenants/${currentTenant.tenantId}`,
      name: currentTenant.name,
      key: 'Tenancy',
    }];

    userRoleAssignments!.forEach((userRoleAssignment) => {
      roleAssignmentProperties.push({
        scope: userRoleAssignment!.scope!,
        name: userRoleAssignment!.scopeName!,
        key: UserDetailsHelper.fetchKeyName(userRoleAssignment!),
      });
    });

    userDetails!.roles!.forEach((role: UserDetailsRole) => {
      const property: RoleAssignmentProperty | undefined = roleAssignmentProperties!.find((prop: any) => prop.scope === role.scope);
      if (property) {
        role.scope = property!.name;
        const keyName: string = `${property!.key}`;
        const roleFirstChar: string = `${role!.role!.substring(0, 1).toUpperCase()}`;
        const roleOtherChars: string = `${role!.role!.substring(1, role!.role!.length)}`;
        role.role = `${keyName} ${roleFirstChar}${roleOtherChars}`;
      }

      if (role.parentScope) {
        const parent: RoleAssignmentProperty | undefined = roleAssignmentProperties!.find((prop: any) => prop.scope === role.parentScope);
        if (parent && parent!.name) {
          role.parentDescription = `${parent!.key}: ${parent!.name}`;
        }
      }
    });
    return userDetails;
  }

  static createFilteredView(currentTenant?: TenantDetailsApi, userRoleAssignments?: UserRoleAssignment[], userDetails?: UserDetail, filteredRoles?: UserRoleAssignment[]) {
    const tenantUser: TenantUser = new TenantUser(userDetails!.id!, userDetails!.name!, userDetails!.firstName!, userDetails!.lastName!, userDetails!.email!, '', TenantRoleType.TenancyNoAccess);
    const userDetail: UserDetail = new UserDetail(tenantUser, filteredRoles!);
    return this.createUserDetailsView(currentTenant!, userDetail, userRoleAssignments);
  }

  static createTenantUserModal(userDetails?: UserDetail): TenantUser {
    return new TenantUser(userDetails!.id!, userDetails!.name!, userDetails!.firstName!, userDetails!.lastName!, userDetails!.email!, '', TenantRoleType.TenancyNoAccess);
  }

  static getPendingInvitation(invitations: TenantUserInvitation[]): TenantUserInvitation {
    const sortedInvitations = [...invitations];
    sortedInvitations.sort((a: TenantUserInvitation, b: TenantUserInvitation) =>
      (a.unixTimestampExpiringDate! < b.unixTimestampExpiringDate! ? 1 : a.unixTimestampExpiringDate! > b.unixTimestampExpiringDate! ? -1 : 0));
    return sortedInvitations.length ? sortedInvitations[0] : new TenantUserInvitation();
  }

  static createInvitationView(invitation: TenantUserInvitation) {
    if (invitation) {
      const invitationDate = new CloudSightDate(invitation!.unixTimestamp!);
      const expDate = new CloudSightDate(invitation!.unixTimestampExpiringDate!);
      const expirationInDays = CloudSightDate.getDaysDifference(Date.now(), expDate!.unixTimestamp!)!;

      invitation.dateDescription = invitationDate.description;
      invitation.expiringInDays = expirationInDays;
    }

    return invitation;
  }
}
